<template>
  <div>
          <b-form-input
            v-model="email"
            :name="storeInArray ? `formData${storeInArray}[${currentField.tagname}]` : `formData[${currentField.tagname}]`"
            :placeholder="currentField.placeholder"
            v-bind="attributesBinding"
            controls-position="left"
            :class="{'is-invalid' : error}"
            >
            </b-form-input>

        <span class="invalid-feedback" role="alert" v-if="error">
            <strong>{{ error }}</strong>
        </span>
  </div>
</template>


<script>
export default {
  name: 'NumberInput',
  props: ['currentField', 'storeInArray', 'value', 'error'],
  data() {
    return {
      email: this.value ? this.value : ''
    }
  },

  watch: {
    value (value) {
      this.email = value ?? ''
    },

    email(value) {
      this.$emit('updated', {
        key: this.currentField.tagname,
        value,
      })
    }
  },

  computed: {
    attributesBinding() {
      var attr = {};
      attr.disabled = this.currentField.disabled;
      attr.step = this.currentField.step;
      attr['step-strictly'] = this.currentField.stepStrictly;
      attr['type'] = "email";
      if (this.currentField.hasMinValue) {
        attr.min = this.currentField.min;
      }
      if (this.currentField.hasMaxValue) {
        attr.max = this.currentField.max;
      }
      return attr;
    }
  }
}
</script>
